import React from 'react'
import { useState } from 'react';
import AddressForm from './Payment/AddressForm';
import PaymentForm from './Payment/PaymentForm'
import Checkout from './Payment/Checkout';
import Review from './Payment/Review';
import Poster from "./Payment/right.png"
import { Box } from '@mui/system';
const Payments = () => {
 
  

  return (
    <div className="container">
   
     <Checkout/> 
    </div>
  );
}

export default Payments